package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsAction
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsState
import com.eladfinish.bible.contest.screens.mikud.ui.dialogs.MikudMenuRow
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogSelectableList
import dev.icerock.moko.resources.compose.localized

// TODO: it's almost the same as LoadMikudDialog
@Composable
internal fun LoadChapterCompletionDialog(
    state: BrowseTabsState.DialogState.SavedCompletions,
    onAction: (BrowseTabsAction) -> Unit,
) {
    BasicDialogWithTitle(
        title = state.title.localized(),
        onDismiss = { onAction(BrowseTabsAction.HideDialog) },
        onCancel = { onAction(BrowseTabsAction.HideDialog) },
    ) {
        val totalPresets = state.presets.size
        val totalSaved = state.savedItems.size
        val totalItems = totalPresets + totalSaved
        val itemsIndices = (0 until totalItems).toList()

        DialogSelectableList(
            list = itemsIndices,
            item = { index, _ ->
                val isPreset = index < totalPresets
                val itemText = if (isPreset) {
                    state.presets[index].localized()
                } else {
                    state.savedItems[index - totalPresets]
                }

                MikudMenuRow(
                    index = index,
                    text = itemText,
                    isPreset = isPreset,
                    onDeleteClicked = {
//                        onAction(BrowseAction.RequestDeleteSavedMikud(name = itemText))
                    },
                    onRenameClicked = {
//                        onAction(BrowseAction.RenameSavedMikud(oldName = itemText))
                    }
                )
            },
            onClick = { index, _ ->
                onAction(BrowseTabsAction.LoadChapterCompletionByIndex(index))
            }
        )
    }
}
